<template>
  <div class='h-toolbarBg'>
    <ejs-toolbar ref='toolBarForBatchImport'>
      <e-items>
        <e-item prefixIcon='icon hero-icon hero-icon-import' :tooltipText='$t("Common.import")' :click='batchManagementNotices' eventType='import'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-batch-edit' :tooltipText='$t("MCS.mod")' :click='batchManagementNotices' eventType='modify'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Common.refresh")' :click='batchManagementNotices' eventType='refresh'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-start-up' :tooltipText='$t("TS.ts_task_oper_start")' :click='batchManagementNotices' eventType='start'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("MCS.del")' :click='batchManagementNotices' eventType='delete'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-disable' :tooltipText='$t("Common.cancel")' :click='batchManagementNotices' eventType='cancel'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-details' :tooltipText='$t("Common.detail")' :click='batchManagementNotices' eventType='detail'></e-item>
        <e-item prefixIcon='icon hero-icon hero-icon-download' :tooltipText='$t("MCS.templateDownload")' :click='batchManagementNotices' eventType='templateDownload'></e-item>
      </e-items>
    </ejs-toolbar>
  </div>
</template>

<script>
  export default {
    name: "BatchManagementButton",
    props: [
      'taskStatusOfBatch' // 存放任务状态
    ],
    methods: {
      batchManagementNotices(args) {
        this.$emit('batchManagementNotices', args.item.eventType);
      }
    },
    watch: {
      // 通过监控任务状态，切换工具栏图标的失效状态
      taskStatusOfBatch(taskStatusOfBatch) {
        //0:等待->删除|取消|查看|模板下载
        //1:运行->查看|模板下载
        //2:失败->执行|修改|删除|查看|模板下载
        //3:成功->执行|修改|删除|查看|模板下载
        //4:取消->执行|修改|删除|查看|模板下载
        switch (taskStatusOfBatch) {
          case 0: // 等待中     0 导入  1 修改  2 刷新  3 开始  4 删除  5 取消  6 详情 7 模板下载
            this.$refs.toolBarForBatchImport.enableItems([0, 2, 4, 5, 6, 7], true);
            this.$refs.toolBarForBatchImport.enableItems([1, 3], false);
            break;
          case 1: // 运行中
            this.$refs.toolBarForBatchImport.enableItems([0, 2, 6, 7], true);
            this.$refs.toolBarForBatchImport.enableItems([1, 3, 4, 5], false);
            break;
          case 2: // 失败
            this.$refs.toolBarForBatchImport.enableItems([0, 1, 2, 3, 4, 6, 7], true);
            this.$refs.toolBarForBatchImport.enableItems([5], false);
            break;
          case 3: // 成功
            this.$refs.toolBarForBatchImport.enableItems([0, 1, 2, 3, 4, 6, 7], true);
            this.$refs.toolBarForBatchImport.enableItems([5], false);
            break;
          case 4: // 取消
            this.$refs.toolBarForBatchImport.enableItems([0, 1, 2, 3, 4, 6, 7], true);
            this.$refs.toolBarForBatchImport.enableItems([5], false);
            break;
          default:
            this.$refs.toolBarForBatchImport.enableItems([0, 2, 7], true);
            this.$refs.toolBarForBatchImport.enableItems([1, 3, 4, 5, 6], false);
            break;
        }
      }
    }
  }
</script>

<style scoped>

</style>
